<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-md-8">
      <b-media class="infopatient shadow bg-white rounded" v-if="this.$route.meta.title== 'Dossier Médical' || this.$route.meta.title == 'Parcours de soins'">
          <div class="" v-if="isEmpty">
            <div class="row mt-3 align-items-center justify-content-center">
                  <i class="ni ni-circle-08 fa-2x text-primary"></i>
                  <h3 class="ml-3 fw-bold m-0">{{patientInformation}}</h3>
            </div>
            <div class="row mt-3">
                  <div class="col-md-12 col-lg-6 col-xl-3"><i class="fa fa-address-book mx-1" aria-hidden="true"></i>{{$t("message.numeroDossier")}}
                  <span class="font-weight-bold text-success">{{patientDossier}}</span></div>
                  <div class="col-md-12 col-lg-6 col-xl-3"><i class="fas" v-bind:class="{ 'fa-male mx-1': isMale, 'fa-female mx-1': !isMale}" aria-hidden="true"></i>Sexe: <span class="font-weight-bold text-success">{{patientSexe}}</span></div>
                  <div class="col-md-12 col-lg-6 col-xl-3 col-xs-12"><i class="fa fa-envelope col-xs-6" aria-hidden="true"></i>Email: <span class="font-weight-bold text-success col-xs-6">{{patientEmail}}</span></div>
                  <div class="col-md-12 col-lg-6 col-xl-3"><i class="fa fa-mobile mx-1" aria-hidden="true"></i>Téléphone: <span class="font-weight-bold text-success">{{patientTelephone}}</span></div>
                  <div class="col-md-12 col-lg-6 col-xl-6 mt-1"><i class="fa fa-calendar mx-1" aria-hidden="true"></i>Age: <span class="font-weight-bold text-success">{{patientDateNaissance}}</span></div>
                  <div class="col-md-12 col-lg-6 col-xl-6 mt-1"><i class="fa fa-birthday-cake mx-1" aria-hidden="true"></i>Date de naissance: <span class="font-weight-bold text-success">{{patientDateN}}</span></div>
                  
            </div>
              <div class="row d-flex justify-content-center mt-3">
                    <span class="ml-3">{{patientMedicasure}} </span>
                      <template v-if="affiliation">
                      <span class="ml-1" v-for="val in affiliation" :key="val.id" :value="val.id">
                      | {{ val.package.description_fr }} ({{ val.status_contrat }} )
                      </span>
                    </template>
                    <template v-if="ancientcontrat">
                      <span  v-for="elt in ancientcontrat" :key="elt.id" :value="elt.id">
                        | CIM
                      </span>
                    </template>
                </div>
          </div>
      </b-media>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col p-0">
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <!-- your content here -->
            <router-view></router-view>
          </fade-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions';
import router from '../router/router';
import BaseNotification from "../components/BaseNotification";
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import _ from 'lodash';
import moment from 'moment';
import $ from 'jquery';
import { ModelSelect } from 'vue-search-select';
import {store} from "../store/store";
import axios from "axios";
import AppConfig from "../constants/AppConfig";

export default {
  data() {
    return {
      isHidden: false,
      halfHide: false,
      bilanHide: false,
      isRed: false,
      isGreen: false,
      isYellow: false,
      mobileView: true,
      halfred: false,
      dropHidden: true,
      affiliation: [],
      ancientcontrat: [],
      items: [
        {
          title:this.$route.name,
          text:this.$route.name,
          to:this.$route.path,
          active:true,
        }
      ],

      item: {
        value: '',
        text: ''
      },
    }
  },
  name: "AdminLayout",

  computed: {
    ...mapGetters(["errors","patient","institutions",'hasPatientRole','hasSouscripteurRole','requiredConfirmationRoutesList','breadcrumbItems']),
  //axios.get(`${AppConfig.apiUrl}/dossier/${this.$route.params.file}`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})

    patientMedicasure:function (){
      let message ='';
      if (!_.isUndefined(this.patient.user)){
        if (this.patient.user.isMedicasure == '1'){
          message = 'Patient MEDICASURE';
        }else{
          message = 'Patient NON MEDICASURE';
        }

        if (this.patient.user.decede == 'oui'){
          message = message+' ( décédé )';
        }

      }
      return message;
    },
    patientInformation:function(){
      let information ="";
      if (!_.isUndefined(this.patient.user)){
        let prenom ="";
        if (!_.isNull(this.patient.user.prenom))
        {
          prenom = this.patient.user.prenom +" ";
        }
        information = prenom.charAt(0).toUpperCase() + prenom.substring(1) + " " + (this.patient.user.nom).toUpperCase();
      }


      return information;
    },
    patientDossier:function(){
      let dossierPatient;
      if (!_.isUndefined(this.patient.dossier)){
        dossierPatient = this.patient.dossier.numero_dossier;
      }
      return dossierPatient;
    },
    patientTelephone:function(){
      let telephone
       if (!_.isUndefined(this.patient.user)){
        telephone = this.patient.user.telephone;
      }
      return telephone;
    },

    patientEmail:function(){
      let email
       if (!_.isUndefined(this.patient.user)){
        email = this.patient.user.email;
      }
      return email;
    },
    patientSexe:function(){
      let sexe
       if (!_.isUndefined(this.patient)){
        sexe = this.patient.sexe;
      }
      return sexe;
    },
    isMale:function(){
       if (this.patient.sexe == 'M'){
        return true
      }
      return false;
    },
    patientDateNaissance:function(){
      let dateNaissance;
      if (!_.isUndefined(this.patient.date_de_naissance)){
        dateNaissance = moment(this.patient.date_de_naissance).format('DD-MM-YYYY');
      }

      if (!_.isUndefined(this.patient.age)){
        let age = 0;
        let nbreMois = 0;
        let nbreJour = 0;
        let moisEncour = moment().month();
        if (moisEncour == 0){
          moisEncour = 1;
        }else{
          moisEncour = moment().month() +1;
        }
        let moisNaissance  = moment(this.patient.date_de_naissance).month() +1;
        age = moment().year() - moment(this.patient.date_de_naissance).year();
        if (moisEncour < moisNaissance){
          age --;
          nbreMois = 12 - moisNaissance + moisEncour;
          if(moment().date() > moment(this.patient.date_de_naissance).date()){
            nbreJour =  moment().date() -   moment(this.patient.date_de_naissance).date();
          }else if(moment().date() < moment(this.patient.date_de_naissance).date()){
            nbreMois--;
            nbreJour = moment(moment().year()+'-'+(moisEncour-1), "YYYY-MM").daysInMonth()
                - moment(this.patient.date_de_naissance).date()   +moment().date() ;
          }else{
            nbreJour = 0;
          }

        }

        else if (moisEncour > moisNaissance){
          nbreMois = moisEncour - moisNaissance;
          if(moment().date() > moment(this.patient.date_de_naissance).date()){
            nbreJour =  moment().date() -   moment(this.patient.date_de_naissance).date();
          }else if(moment().date() < moment(this.patient.date_de_naissance).date()){
            nbreMois--;
            nbreJour = moment(moment().year()+'-'+(moisEncour-1), "YYYY-MM").daysInMonth()
                - moment(this.patient.date_de_naissance).date()   +moment().date() ;
          }else{
            nbreJour = 0;
          }
        }
        else if (moisEncour == moisNaissance){
          if (moment().date() > moment(this.patient.date_de_naissance).date()){
            nbreJour = moment().date() - moment(this.patient.date_de_naissance).date();
          }else if (moment().date() < moment(this.patient.date_de_naissance).date()){
            age --;
            nbreMois =11;
            nbreJour =  moment().date();

          }
        }


        return dateNaissance = "( " + age +" Ans " +  nbreMois +" Mois " + nbreJour +" Jours ) ";
      }
    },

    patientDateN:function(){
      let dateN;
      if (!_.isUndefined(this.patient.date_de_naissance)){
        dateN = moment(this.patient.date_de_naissance).format('DD-MM-YYYY');
      }
      return dateN;
    },

    isFemale:function () {
      if (!_.isUndefined(this.patient.sexe)){
        return this.patient.sexe =="F";
      }
      return false;
    },
    isEmpty:function(){
      if (!_.isUndefined(this.patient)){
        return !_.isEmpty(this.patient);
      }
      return false;
    },

    options:function(){
      let oArray = [];

      _.forEach(this.institutions, function (institution) {
        oArray.push({value:institution.id, text:  institution.name});
      })  ;
      oArray.push({value:'0',text:'All'});
      return oArray;
    },
  },

  components: {
    FadeTransition,
    ModelSelect
  },

  watch: {

    $route(to, from) {
      let self = this;

    },
    item(newValue, lastValue){
      if (newValue.value != '0'){
        this.onEtablissementClick(newValue.value);
      }
      else{
        this.$store.dispatch('setselectedInstitution', { selectedInstitution : {} });
      }

    },

    errors(newValue, oldValue) {
      let eArray = ["accessRefuse", "dejaAffilie", "nonTransmis", "uniqueDossier", "deletingError"];
      _.forEach(eArray, function (e) {
        if (newValue.hasOwnProperty(e)) {
          Swal.fire({
                icon: 'error',
                title:newValue[e][0],
                text:'',
                timer: 2500,
              }
          );
        }
      })

    }
  },
  methods: {

     handleView() {
      this.mobileView = window.innerWidth <= 990;
    },

     dropDown() {
          var y = document.getElementById("myDIV")
          var x = document.getElementById("myDropdown");
              if (x.style.display === "none") {
                x.style.display = "block";
                y.style.backgroundColor = "white";
              } else {
                x.style.display = "none";
                y.style.backgroundColor = "#2dcecc";
        }
      },
      logOut(){
        let args = {
          user: localStorage.getItem('user')
        };

        let successMessage = this.$i18n.t('message.disconnectMessage');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };
        this.$store.dispatch('logoutHandler',{args, errorMessages, successMessage});
      },
      
    newAffiliation() {
      
      if( !_.isNull(this.patient) && (this.$route.meta.title== 'Dossier Médical' || this.$route.meta.title == 'Parcours de soins') ){
      let slug = this.$route.params.file;
      axios.get(`${AppConfig.apiUrl}/dossier/`+ slug, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
      .then(res=>{
        this.affiliation = res.data.affiliation;
        this.ancientcontrat = res.data.cim.contrat;
      })
      }
    },
    changeOpacity () {
      this.halfHide = true
      this.halfred = false
    },
    backOpacity(){
       this.halfHide = false
       this.halfred = true
    },


    onEtablissementClick(etablissementId){
      let etablissement = _.filter(this.institutions,function (institution) {
        return institution.id == etablissementId;
      });
      this.$store.dispatch('setselectedInstitution', { selectedInstitution : etablissement });
    },


    getInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getInstitutions', { args : args });
    },


    toMedicalFile() {
      this.$router.push({ name: 'medical-file', params: { file: this.patient.dossier.slug } });
    },

  },

  created() {
    this.handleView();
    window.addEventListener('resize', this.handleView);
    let self = this;
    $("body").on("mousemove",function(evt) {
      let dernierActivite = new Date(localStorage.getItem('activite'));
      let nouvelleActivite = new Date(moment());
      let difference = Math.abs(Math.round(((nouvelleActivite - dernierActivite) / 1000 ) / 60));
      if (difference <30){
        localStorage.setItem('activite', moment());
      }else{
        evt.preventDefault();
        $("body").off("mousemove");
        if(!window.location.href.includes('/login')){
          localStorage.setItem('ancestor_link', window.location.href);
        }
        self.logOut();
      }
    });
  },

  mounted() {
    // Fetch institution list
    // this.getInstitutions();
  this.newAffiliation();
  // this.ancieneAffiliation();
    if(this.$route.name == 'medical-file'){
      let item = {
        title:'medical-management',
        text:this.$i18n.t('message.medicalManagement'),
        to:'/dashboard/medical-management/',
      };
      // this.$store.dispatch('clearBreadcrumbItems', { });

      this.$store.dispatch('putOnTopItem', { item : item});
    }
  }
}
</script>

<style scoped>

</style>
